/**
 * Mapeamento PDV (FuncionalidadeCodigo) → permissão do portal.
 * Fonte única para menu, rotas e login mapper.
 */
export const PDC_FUNCIONALIDADE_TO_PERMISSION = {
  inicio_acesso: 'home',
  faturamento_acesso: 'finan',
  avaria_acesso: 'damageCharge',
  vamoscontrole_acesso: 'vamosControl',
  relatorios_distribuicao_geografica: 'fleetDist',
  relatorios_manutencao: 'entraceExit',
  relatorios_modelos: 'models',
  relatorios_servicos: 'services',
  agendamento_agendar: 'createSchedule',
  agendamento_relatorio: 'scheduleList',
  agendamento_lote: 'multiple',
  multas_acesso: 'fines',
  chamados_acesso: 'callCenter',
  servicos_manutencao_acesso: 'maintenanceServices',
  crlv_acesso: 'crlv',
  comunicados_acesso: 'communique',
  logs_acesso: 'logs',
  faq_acesso: 'faq',
} as const satisfies Record<string, Permission>;

export const LEGACY_ROTA_TO_PERMISSION = {
  inicio: 'home',
  'report-geo-distribution': 'fleetDist',
  'report-maintenance': 'entraceExit',
  'report-models': 'models',
  'report-service': 'services',
  scheduling: 'createSchedule',
  'scheduling-report': 'scheduleList',
  'scheduling-batch': 'multiple',
  agendamentolote: 'multiple',
  faq: 'faq',
  faturamento: 'finan',
  logsacesso: 'logs',
  crlv: 'crlv',
  multas: 'fines',
  comunicados: 'communique',
} as const satisfies Record<string, Permission>;

export const REPORT_PERMISSIONS: ReadonlyArray<Permission> = [
  'models',
  'fleetDist',
  'entraceExit',
  'services',
];

export const SCHEDULE_PERMISSIONS: ReadonlyArray<Permission> = [
  'createSchedule',
  'scheduleList',
  'multiple',
];

export const VEHICLE_MANAGEMENT_PERMISSIONS: ReadonlyArray<Permission> = [
  'crlv',
  'damageCharge',
];

export const PORTAL_MULTAS_ROUTE = '/portal/multas';

export const ADMIN_PERMISSIONS: ReadonlyArray<Permission> = [
  'logs',
  'communique',
  'access',
];

/** Prefixo de rota → permissões exigidas (basta uma). Ordem: mais específico primeiro. */
export const ROUTE_PERMISSION_PREFIXES: ReadonlyArray<{
  prefix: string;
  permissions: ReadonlyArray<Permission>;
}> = [
  { prefix: '/relatorios/modelos', permissions: ['models'] },
  { prefix: '/relatorios/distdefrotas', permissions: ['fleetDist'] },
  {
    prefix: '/relatorios/manutencao/entradasaida',
    permissions: ['entraceExit'],
  },
  { prefix: '/relatorios/manutencao/servicos', permissions: ['services'] },
  { prefix: '/relatorios', permissions: REPORT_PERMISSIONS },
  { prefix: '/novo-agendamento/lote', permissions: ['createSchedule', 'multiple'] },
  { prefix: '/novo-agendamento', permissions: ['createSchedule'] },
  { prefix: '/agendamentos', permissions: SCHEDULE_PERMISSIONS },
  { prefix: '/novo-chamado/lote', permissions: ['callCenter', 'createSchedule', 'multiple'] },
  { prefix: '/novo-chamado', permissions: ['callCenter'] },
  { prefix: '/chamados', permissions: ['callCenter'] },
  { prefix: '/servicos-manutencao', permissions: ['maintenanceServices'] },
  { prefix: '/faturamento', permissions: ['finan'] },
  { prefix: '/centraldeduvidas', permissions: ['faq'] },
  { prefix: '/gestao/veiculos', permissions: ['crlv'] },
  { prefix: '/gestao/cobrancas', permissions: ['damageCharge'] },
  { prefix: '/portal/multas', permissions: ['fines'] },
  { prefix: '/administrativo/logs', permissions: ['logs'] },
  { prefix: '/administrativo/comunicados', permissions: ['communique'] },
  { prefix: '/comunicados', permissions: ['communique'] },
  { prefix: '/acessos', permissions: ['access'] },
  { prefix: '/inicio', permissions: ['home'] },
];
